import React, { useState, useEffect } from 'react';
import styles from './evaluationTemplates.module.scss';
import {
    Route,
    Switch,
    Redirect,
    NavLink
} from 'react-router-dom';
import { Col } from 'react-bootstrap';
import QuizTemplates from './quizTemplates';
import CustomNavbar from '../customNavbar';
import { CustomAlertBox } from '../../shared/customAlertBox';
import { useHistory } from "react-router-dom";
import ViewQuizTemplates from './quizTemplates/viewQuizTemplate';
import OneWayInterviewTemplates from './oneWayInterviewTemplates';

const EvaluationTemplates = (props) => {
    let [isURLLoading, setURLLoading] = useState(false);
    const breadcrumb = [
        {
            pathaddress: '',
            pathname: 'Templates',
            isActive: true,
            key: 1 + 'Templates'
        }
    ];

    let history = useHistory();

    let main_props = {
        permissions: props.permissions,
        role: props.role,
        toggleInterviewView: props.toggleInterviewView
    }

    return (
        <div>
            <div className={styles.settingsBodyContainer}>
                <div className={styles.backgroundFixedComponents}>
                    <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                </div>
                <div className={styles.companySettingsBodyWrapper}>
                    <ul className={styles.tabOptionsContainer}>
                        <NavLink to="/app/company/templates/quiz-templates" id="evaluation_templates_quiz_templates_nav" activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}>
                            <li className={styles.switchActive}> <p className={styles.settingsContentSwitch}>Quiz Templates</p></li>
                        </NavLink>
                        <NavLink to="/app/company/templates/one-way-interview-templates" id="evaluation_templates_one_way_interview_templates_nav" activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}>
                        <li className={styles.switchActive}><p className={styles.settingsContentSwitch}>One Way Interview Templates</p></li>
                    </NavLink>
                    </ul>
                    <Switch>
                        <Route path='/app/company/templates/quiz-templates' exac={true} render={props => <QuizTemplates main_props={main_props}  {...props} />} />
                        <Route path='/app/company/templates/one-way-interview-templates' exac={true} render={props => <OneWayInterviewTemplates main_props={main_props} {...props} />} />
                        <Redirect from="/" to="/app/company/templates/quiz-templates" />
                    </Switch>
                </div>
            </div>
        </div>
    )
}

export default EvaluationTemplates;